<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="primary">
        <span class="white--text">
          {{ $t('partstatusmanagement.additem') }}
        </span>
      </v-card-title>
      <v-card-text style="height: 700px;" class="pt-0">
        <v-form ref="form" v-model="valid" lazy-validation class="mt-5">
          <v-autocomplete
            class="mt-0"
            dense
            :items="substationlist"
            outlined
            v-model="partstatusobj.substation"
            :label="$t('partstatusmanagement.label.substationname')"
            item-text="name"
            item-value="id"
            return-object
            clearable
            :rules="rules.substation"
          >
          </v-autocomplete>
          <v-autocomplete
            class="mt-0"
            dense
            :items="substationlist"
            outlined
            v-model="partstatusobj.substation"
            :label="$t('partstatusmanagement.label.substationid')"
            item-text="id"
            item-value="id"
            disabled
          >
          </v-autocomplete>
          <v-autocomplete
            class="mt-0"
            dense
            :items="overallresultlist"
            outlined
            v-model="partstatusobj.overallresult"
            :label="$t('partstatusmanagement.label.overallresult')"
            item-text="name"
            item-value="id"
            return-object
            clearable
            :rules="rules.overallresult"
          >
          </v-autocomplete>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.mainid"
            :label="$t('partstatusmanagement.label.maindid')"
            :rules="rules.maindid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.linename"
            :label="$t('partstatusmanagement.label.linename')"
            :rules="rules.linename"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.lineid"
            :label="$t('partstatusmanagement.label.lineid')"
            :rules="rules.lineid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.carrierid"
            :label="$t('partstatusmanagement.label.carrierid')"
            :rules="rules.carrierid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.producttypename"
            :label="$t('partstatusmanagement.label.producttypename')"
            :rules="rules.producttypename"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.recipename"
            :label="$t('partstatusmanagement.label.recipename')"
            :rules="rules.recipename"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.productid"
            :label="$t('partstatusmanagement.label.productid')"
            :rules="rules.productid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.packagebatchid"
            :label="$t('partstatusmanagement.label.packagebatchid')"
            :rules="rules.packagebatchid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.ordername"
            :label="$t('partstatusmanagement.label.ordername')"
            :rules="rules.ordername"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.ordernumber"
            :label="$t('partstatusmanagement.label.ordernumber')"
            :rules="rules.ordernumber"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.ordertype"
            :label="$t('partstatusmanagement.label.ordertype')"
            :rules="rules.ordertype"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.sublineid"
            :label="$t('partstatusmanagement.label.sublineid')"
            :rules="rules.sublineid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.customername"
            :label="$t('partstatusmanagement.label.customername')"
            :rules="rules.customername"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.checkoutngcode"
            :label="$t('partstatusmanagement.label.checkoutngcode')"
            :rules="rules.checkoutngcode"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.completedproductid"
            :label="$t('partstatusmanagement.label.completedproductid')"
            :rules="rules.completedproductid"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.nexttargetstation"
            :label="$t('partstatusmanagement.label.nexttargetstation')"
            :rules="rules.nexttargetstation"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.modestatus"
            :label="$t('partstatusmanagement.label.modestatus')"
            :rules="rules.modestatus"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            autocomplete="off"
            v-model="partstatusobj.roadmapid"
            :label="$t('partstatusmanagement.label.roadmapid')"
            :rules="rules.roadmapid"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text class="text-none" @click="dialog = false">
          {{ $t('partstatusmanagement.btn.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          class="text-none"
          :loading="saving"
          :disabled="!valid
            || !partstatusobj.substation
            || !partstatusobj.overallresult
            || !partstatusobj.mainid"
          @click="submit"
        >
          {{ $t('partstatusmanagement.btn.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'AddPartstatus',
  data() {
    return {
      partstatusobj: {
      },
      rules: {
        substation: [(v) => !!v || 'Substation Name is required!'],
        overallresult: [(v) => !!v || 'Overall Result is required!'],
        maindid: [(v) => !!v || 'Maind Id is required!'],
      },
      overallresultlist: [
        { name: 1, id: 1 },
        { name: 2, id: 2 },
        { name: 7, id: 7 },
      ],
      substationlist: [],
      valid: false,
      saving: false,
    };
  },
  props: ['partstatusselected', 'showAddDialog'],
  async created() {
    const substationlist = await this.getElement({ elementname: 'substation' });
    this.substationlist = substationlist;
    this.valid = false;
  },
  mounted() {
    this.valid = false;
  },
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapActions('partstatusManagement', ['getElement', 'postElement']),
    async getPartList(mainid) {
      const partstatuslist = await this.getElement({
        elementname: 'partstatus',
        query: `?query=mainid=="${mainid}"`,
      });
      if (partstatuslist.length > 0) {
        return true;
      }
      return false;
    },
    async submit() {
      this.saving = true;
      const { partstatusobj } = this;
      const hasPartstatus = await this.getPartList(partstatusobj.mainid);
      if (hasPartstatus) {
        this.setAlert({
          show: true,
          type: 'error',
          message: 'Main Id已经存在！',
        });
        this.saving = false;
        return;
      }
      const {
        substation,
        overallresult,
        linename,
        lineid,
        carrierid,
        producttypename,
        recipename,
        productid,
        packagebatchid,
        ordername,
        ordernumber,
        ordertype,
        sublineid,
        customername,
        checkoutngcode,
        completedproductid,
        nexttargetstation,
        modestatus,
        roadmapid,
        mainid,
      } = partstatusobj;
      const payload = {
        substationname: substation.name,
        substationid: substation.id,
        overallresult: overallresult.id,
        linename,
        lineid,
        carrierid,
        producttypename,
        recipename,
        productid,
        packagebatchid,
        ordername,
        ordernumber,
        ordertype,
        sublineid,
        customername,
        checkoutngcode,
        completedproductid,
        nexttargetstation,
        modestatus,
        roadmapid,
        mainid,
        assetid: 4,
      };
      const postData = {
        elementname: 'partstatus',
        payload,
      };
      const result = await this.postElement(postData);
      this.saving = false;
      if (result) {
        this.setAlert({
          show: true,
          type: 'success',
          message: 'ADD_SUCCESS',
        });
        this.$emit('add');
      } else {
        this.setAlert({
          show: true,
          type: 'error',
          message: 'ERROR_IN_ADD',
        });
      }
    },
  },
  computed: {
    dialog: {
      get() {
        return this.showAddDialog;
      },
      set() {
        this.$emit('cancel');
      },
    },
  },
  watch: {
    async partstatusselected(partstatusselected) {
      if (!partstatusselected) {
        return false;
      }
      const {
        overallresult,
        substationname,
        substationid,
        linename,
        lineid,
        carrierid,
        producttypename,
        recipename,
        productid,
        packagebatchid,
        ordername,
        ordernumber,
        ordertype,
        sublineid,
        customername,
        checkoutngcode,
        completedproductid,
        nexttargetstation,
        modestatus,
        roadmapid,
        mainid,
      } = partstatusselected;
      this.partstatusobj = {
        overallresult: {
          name: Number(overallresult),
          id: Number(overallresult),
        },
        substation: {
          name: substationname,
          id: substationid,
        },
        linename,
        lineid,
        carrierid,
        producttypename,
        recipename,
        productid,
        packagebatchid,
        ordername,
        ordernumber,
        ordertype,
        sublineid,
        customername,
        checkoutngcode,
        completedproductid,
        nexttargetstation,
        modestatus,
        roadmapid,
        mainid,
      };
      console.log(partstatusselected, 'partstatusselected');
      console.log(this.partstatusobj, 'this.partstatusobj');
      return true;
    },
  },
};
</script>
